import { RouteRecordRaw } from "vue-router";

const aiAcademyRoutes: RouteRecordRaw[] = [
  {
    path: "/aiAcademy",
    name: "aiAcademy",
    meta: {
      label: "AI学院",
      auth: false,
      useTopbar: true,
      layout: "home" // 使用工作台布局
    },
    component: () => import("@/views/aiAcademy/index.vue")
  },
  {
    path: "/aiAcademy/detail",
    name: "aiAcademyDetail",
    meta: {
      label: "AI学院详情",
      auth: false,
      useTopbar: true,
      layout: "simple" // 使用工作台布局
    },
    component: () => import("@/views/aiAcademy/children/aiAcademyDetail.vue")
  }
];

export default aiAcademyRoutes;
